// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3e77f5ac","453":"e8a3f521","667":"9fe566b0"}[chunkId] + ".chunk.js";
};